var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "#2E3A59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10864 6.79617L1.83766 11.015C1.2206 11.3727 0.428711 10.9396 0.428711 10.2185V1.78087C0.428711 1.06098 1.21946 0.626751 1.83766 0.985557L9.10864 5.20439C9.249 5.28452 9.36568 5.40035 9.44684 5.54013C9.52799 5.6799 9.57074 5.83866 9.57074 6.00028C9.57074 6.16191 9.52799 6.32066 9.44684 6.46044C9.36568 6.60021 9.249 6.71604 9.10864 6.79617V6.79617Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.54d5abb1.svg";
export { ForwardRef as ReactComponent };